module.exports = __webpack_public_path__ + "static/hero-small-enterprise-0c4250d75f55485e90a94ba345e9ad0b.svg";